<!--
 * @Author: 田鑫
 * @Date: 2022-01-06 10:42:33
 * @LastEditors: 田鑫
 * @LastEditTime: 2022-01-06 17:18:34
 * @Description: 厨师标签管理
-->

<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>年夜饭预定管理</el-breadcrumb-item>
        <el-breadcrumb-item>厨师标签管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="hx-form-container box-shadow">
      <el-form ref="listForm" :model="listParams" label-width="120px" inline>
        <el-form-item label="厨师标签名称：" prop="name">
          <el-input
            style="width: 300px"
            v-model="listParams.name"
            placeholder="请填写厨师标签名称"
          ></el-input>
        </el-form-item>

        <el-form-item label="">
          <el-button @click="loadTableData" type="primary">查询</el-button>
        </el-form-item>
      </el-form>

      <hx-table-result
        :page-info="pager"
        :loading="tableLoading"
        @page-current-change="handleCurrentChange"
        @page-size-change="handleSizeChange"
      >
        <div slot="action"></div>

        <hx-table-result-col>
          <div class="wrap-table-info-display">
            <el-button @click="openDialog" type="primary">新增</el-button>
            <span class="table-info-display">
              <span>总条数：</span>
              <span class="alert-text ft16">{{ pager.total }}</span>
            </span>
          </div>
        </hx-table-result-col>

        <el-table slot="content" :data="tableData" max-height="600" border>
          <el-table-column fixed align="center" width="60" label="序号">
            <template slot-scope="scope">
              <span
                v-text="
                  (pager.pageIndex > 1
                    ? (pager.pageIndex - 1) * pager.pageSize
                    : 0) +
                  scope.$index +
                  1
                "
              >
              </span>
            </template>
          </el-table-column>
          <el-table-column
            label="厨师标签名称"
            prop="name"
            align="center"
          ></el-table-column>
          <el-table-column
            label="厨师标签排序"
            prop="name"
            align="center"
          ></el-table-column>
          <el-table-column label="操作" prop="" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="editItem(scope.row.id)"
                >编辑</el-button
              >
              <confirm-button
                type="text"
                style="margin: 0 10px"
                title="确认要删除该厨师标签吗？"
                @confirmed="deleteItem(scope.row.id)"
              >
                <span>删除</span>
              </confirm-button>
            </template>
          </el-table-column>
        </el-table>
      </hx-table-result>
    </div>
    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      @close="$refs['dialogForm'].resetFields()"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form ref="dialogForm" :model="dialogForm" :rules="dialogRules">
        <el-form-item label="厨师标签名称：" prop="dialogName">
          <el-input
            v-model="dialogForm.dialogName"
            placeholder="请填写厨师标签名称"
            maxlength="10"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="" style="text-align: center">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button
            @click="saveDialog('dialogForm')"
            type="primary"
            :disabled="isDisabled"
            >保存</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      listParams: {
        name: "",
      },
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
      },
      tableData: [],
      tableLoading: false,
      dialogVisible: false,
      dialogForm: {
        dialogName: "",
      },
      dialogRules: {
        dialogName: [
          { required: true, message: "请填写厨师标签名称", trigger: "blur" },
        ],
      },
      isDisabled: false,
    };
  },
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    this.loadTableData();
  },
  //生命周期 - 方法
  methods: {
    /**
     * @description: 加载列表
     * @param {*}
     * @return {*}
     */
    loadTableData() {},
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    },
    /**
     * @description: 编辑厨师标签
     * @param {*} id
     * @return {*}
     */
    editItem(id) {},
    /**
     * @description: 删除厨师标签
     * @param {*} id
     * @return {*}
     */
    deleteItem(id) {},
    /**
     * @description: 打开弹框
     * @param {*}
     * @return {*}
     */
    openDialog() {},
    /**
     * @description: 保存表单
     * @param {*} name
     * @return {*}
     */
    saveDialog(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
        }
      });
    },
  },
};
</script>
<style lang='scss' scoped>
</style>